import { useState, useEffect, useRef, useCallback } from "react";
import api from "../api";

// Refresh at 80% of TTL to avoid using an expired token
const REFRESH_THRESHOLD = 0.8;

export default function useMcpToken() {
  const [token, setToken] = useState(null);
  const [tokenError, setTokenError] = useState(null);
  const isRefreshing = useRef(false);
  const timerRef = useRef(null);

  const fetchToken = useCallback(async () => {
    if (isRefreshing.current) return;
    isRefreshing.current = true;
    try {
      const response = await api.getMcpToken();
      setToken(response.data.accessToken);
      setTokenError(null);

      // Schedule proactive refresh at 80% of TTL
      const expiresIn = response.data.expiresIn;
      if (expiresIn) {
        if (timerRef.current) clearTimeout(timerRef.current);
        const refreshMs = expiresIn * 1000 * REFRESH_THRESHOLD;
        timerRef.current = setTimeout(() => {
          isRefreshing.current = false;
          fetchToken();
        }, refreshMs);
      }
    } catch (err) {
      console.error("Failed to get MCP token:", err);
      setTokenError(err);
    } finally {
      isRefreshing.current = false;
    }
  }, []);

  useEffect(() => {
    fetchToken();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [fetchToken]);

  return { token, tokenError, refreshToken: fetchToken };
}
